// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width:1024px){._16N04{width:96rem}}", ""]);
// Exports
exports.locals = {
	"root": "_16N04"
};
module.exports = exports;
